import { CreatedByUser } from '../../types/apps/apps.types';
import { FeatureName } from '../Feature/feature';
import { ModuleNameEnum } from '../Module/module';
import { apps } from '../rolesAndPermission';

export const cateringModule = {
  catering: {
    id: 73,
    moduleName: ModuleNameEnum.CATERING,
  },
} as const;
export const cateringModuleList = Object.entries(cateringModule).map(([key, v]) => ({
  key,
  createdBy: CreatedByUser.SYSTEM,
  ...v,
}));
export const cateringFeatures = {
  dashboard: { id: 218, featureName: FeatureName.DASHBOARD },
  'invoice-management': { id: 219, featureName: FeatureName.INVOICE_MANAGEMENT },
  'package-configuration': { id: 220, featureName: FeatureName.PACKAGE_CONFIGURATION },
  'email-templates': { id: 221, featureName: FeatureName.EMAIL_TEMPLATES },
} as const;
export const cateringFeaturesList = Object.entries(cateringFeatures).map(([key, v]) => ({
  key,
  ...v,
  createdBy: CreatedByUser.SYSTEM,
}));

export const cateringAppModule = [{ appId: apps.dashboard.id, moduleId: cateringModule['catering'].id }];

export const cateringModuleFeatureList = [
  { moduleId: cateringModule['catering'].id, featureId: cateringFeatures['dashboard'].id },
  { moduleId: cateringModule['catering'].id, featureId: cateringFeatures['invoice-management'].id },
  { moduleId: cateringModule['catering'].id, featureId: cateringFeatures['package-configuration'].id },
  { moduleId: cateringModule['catering'].id, featureId: cateringFeatures['email-templates'].id },
];

export const cateringRemainingFeatures = {
  'payment-configuration': { id: 248, featureName: FeatureName.PAYMENT_CONFIGURATION },
  calendar: { id: 249, featureName: FeatureName.CALENDAR },
  'email-inbox': { id: 250, featureName: FeatureName.EMAIL_INBOX },
};

export const cateringRemainingFeaturesList = Object.entries(cateringRemainingFeatures).map(([key, v]) => ({
  key,
  ...v,
  createdBy: CreatedByUser.SYSTEM,
}));

export const cateringRemainingModuleFeatureList = [
  { moduleId: cateringModule['catering'].id, featureId: cateringRemainingFeatures['payment-configuration'].id },
  { moduleId: cateringModule['catering'].id, featureId: cateringRemainingFeatures['email-inbox'].id },
  { moduleId: cateringModule['catering'].id, featureId: cateringRemainingFeatures['calendar'].id },
];
